import { ShootCategory } from './shoot-category.model';

export class ShootSub {
    id?: number;
    name?: string;
    shootCategoryId?: number;
    shootCategory?: ShootCategory = {};
    selected?: boolean = false;
}